export var NUM_PLATFORMS_IN_VIEWPORT = 8;
